import type { LanguageOption } from '@amzn/journeys-common';
import type { FC } from 'react';
import { BullseyeMultiselect } from './BullseyeMultiselect';
import { JFormMultiselect, type JFormMultiselectProps } from './JFormMultiselect';

export interface JFormBullseyeMultiselectProps extends JFormMultiselectProps {
  language: LanguageOption | null | undefined;
}

export const JFormBullseyeMultiselect: FC<JFormBullseyeMultiselectProps> = (props) => (
  <JFormMultiselect {...props} number>
    {(renderProps) => <BullseyeMultiselect {...renderProps} language={props.language} />}
  </JFormMultiselect>
);
